import TextInput from '../../../../atoms/inputs/text-input';
import {
  InlineEditableInputWrapper,
  type InlineEditableInputWrapperProps,
} from '../inline-editable-input-wrapper';
import { getInlineInputRemPadding } from '../../../../atoms/buttons/button/button.styles';

interface InlineNumberInputProps
  extends Omit<InlineEditableInputWrapperProps, 'children'> {
  placeholder?: string;
  min?: number;
  max?: number;
  step?: number;
}

export const InlineNumberInput: React.FC<InlineNumberInputProps> = ({
  placeholder,
  min,
  max,
  step = 1,
  size = 'sm',
  ...props
}) => {
  const inlineInputPadding = getInlineInputRemPadding(size);

  return (
    <InlineEditableInputWrapper {...props} size={size}>
      {({ value, onChange, disabled }) => (
        <TextInput
          className="w-full"
          style={{ paddingRight: `${inlineInputPadding}rem` }}
          value={value}
          onChange={(e) => {
            const newValue = e.target.value;
            if (newValue === '') {
              onChange('');
            } else {
              const numValue = parseFloat(newValue);
              if (!isNaN(numValue)) {
                onChange(newValue);
              }
            }
          }}
          placeholder={placeholder ?? props.label}
          size={size}
          shadow="inset-sm"
          disabled={disabled}
          type="number"
          min={min}
          max={max}
          step={step}
        />
      )}
    </InlineEditableInputWrapper>
  );
};
